import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Pagination, Button as AntdButton } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useSiteList } from "./hooks";
import { SiteList } from "./components";
import { PageWrapper, HeaderRow, Title, PaginationWrapper } from "./siteList.styles";
const PAGE_SIZE = 12;
const SiteListPage = () => {
    const { loading, sites, total, current, handlePageChange, handleSiteClick, handleBackToOrganisations, } = useSiteList();
    return (_jsxs(PageWrapper, { children: [_jsxs(HeaderRow, { children: [_jsx(AntdButton, { type: "text", icon: _jsx(ArrowLeftOutlined, {}), onClick: handleBackToOrganisations, style: { marginRight: 16 }, children: "Back to Organisations" }), _jsx(Title, { children: "Sites" })] }), _jsx(SiteList, { sites: sites, loading: loading, onSiteClick: handleSiteClick }), _jsx(PaginationWrapper, { children: _jsx(Pagination, { current: current, pageSize: PAGE_SIZE, total: total, onChange: handlePageChange, showSizeChanger: false }) })] }));
};
export default SiteListPage;
